import React from 'react';
import { FormControl, TextField, InputAdornment, Autocomplete, Box, Tooltip} from '@mui/material';
import { Controller } from 'react-hook-form';
import ErrorIcon from '@mui/icons-material/Error';

const AutocompleteInput = ({ control, trigger, name, value, label, options,disabled, error, helperText, handleBlur, onFocus, onChange, forModalPopup = false, size = "normal" }) => {
   return ( <FormControl fullWidth margin="normal">
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Autocomplete
                    name={name}
                    disablePortal
                    selectOnFocus
                    clearOnBlur
                    options={options}
                    disabled={disabled || undefined}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value}
                    value={options?.find(option => option.value === (value || field.value)) || null}
                    onChange={(e, newValue) => {
                        const newValueOrNull = newValue ? newValue.value : null;
                        field.onChange(newValueOrNull);
                        if (trigger) trigger(name);
                        if (onChange) onChange(e, newValueOrNull);
                    }}

                    renderOption={(props, option) => (
                        option.description ? (
                            <Tooltip
                                key={option.value}
                                title={option.description}
                                placement="right"
                                arrow
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            width: 420,
                                            maxWidth: '90vw',
                                            bgcolor: '#FFFFFF',
                                            color: '#4D4C52',
                                            fontFamily: '"Proxima Nova Rg"',
                                            fontSize: '14px',
                                            lineHeight: '22px',
                                            letterSpacing: '0.15px',
                                            padding: '12px 14px',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                            border: '1px solid #E0E0E0',
                                        },
                                    },
                                    arrow: {
                                        sx: {
                                            color: '#FFFFFF',
                                            '&::before': {
                                                border: '1px solid #E0E0E0',
                                            },
                                        },
                                    },
                                }}
                            >
                                <li {...props}>{option.label}</li>
                            </Tooltip>
                        ) : (
                            <li {...props} key={option.value}>{option.label}</li>
                        )
                    )}

                    renderInput={(params) => (
                        <TextField
                            {...params}   
                            size={size}                         
                            name={name}
                            label={label}
                            error={!!error}
                            helperText={helperText}
                            onBlur={(e) => {
                                field.onBlur(e);
                                if (handleBlur) handleBlur(e);
                            }}
                            onFocus={onFocus}
                            slotProps={{
                                input: {
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {forModalPopup ? (
                                                <Box sx={{position:'absolute' , right:' 0px', top: '35%'}}>
                                                    {params.InputProps.endAdornment}
                                                </Box>
                                            ): (params.InputProps.endAdornment)}                                            
                                            {error && (
                                                <InputAdornment position="end">
                                                    <ErrorIcon style={{ color: 'red' }} />
                                                </InputAdornment>
                                            )}
                                        </>
                                    ),
                                },
                            }}
                        />
                    )}
                />
            )}
        />
    </FormControl>
)
}

export default AutocompleteInput;